/** @jsx jsx */
import React, { useEffect, useMemo, useRef } from 'react'
import { jsx } from 'theme-ui'

import Card from '../../card'
import FlexButtons from '../../flex-buttons'
import ImageFill, { ImageInline, RatioBox } from '../../image'
import Paragraph from '../../paragraph'
import VideoWrapper from '../../video-wrapper'
import { scrollToEl } from '../../scroll-manager'
import Link from '../../link'

import { FlexCols, FlexCol, VStack, HStack } from '../../../styles/els'
import { formatImage, LinkTypes, resolveButtons } from '../../../lib/helpers'

const Videos = (props) => {
  const { videoGroups, ...otherProps } = props
  const groupElRefs = useRef([])
  const buttons = useMemo(() => {
    return videoGroups.map((_group, _i) => {
      return {
        label: _group.heading,
        onClick: (e) => {
          e.preventDefault()
          e.stopPropagation()

          const _el = groupElRefs.current[_i]
          scrollToEl(_el)
        },
      }
    })
  }, [videoGroups])

  useEffect(() => {
    groupElRefs.current = groupElRefs.current.slice(0, videoGroups.length)
  }, [videoGroups])

  return videoGroups && videoGroups.length > 0 ? (
    <>
      <FlexButtons label="Show me" buttons={buttons} />
      <Card color="dark1">
        <VStack space={8}>
          {videoGroups.map((_group, _i) => {
            return (
              <div key={_i} ref={(el) => (groupElRefs.current[_i] = el)}>
                {_group.heading ? (
                  <Paragraph
                    heading={_group.heading}
                    hTier={3}
                    text={_group.subheading}
                    align="center"
                    sx={{
                      pb: 7,
                      maxWidth: '720px',
                      mx: 'auto',
                    }}
                  />
                ) : null}
                <FlexCols>
                  {_group.videos && _group.videos.length > 0
                    ? _group.videos.map((_video, _i) => {
                        const {
                          video,
                          embed,
                          imagePlaceholder,
                          type,
                          linkUrl,
                          label,
                        } = _video
                        const _image = formatImage(imagePlaceholder)

                        return (
                          <FlexCol key={_i} base={[1, null, null, 2]}>
                            {type === 'link' ? (
                              <Link to={linkUrl} type={LinkTypes.EXTERNAL}>
                                <RatioBox
                                  ratio={9 / 16}
                                  sx={{
                                    backgroundColor: 'b2',
                                    borderRadius: 1,
                                  }}
                                >
                                  {_image ? <ImageFill image={_image} /> : null}
                                </RatioBox>
                              </Link>
                            ) : (
                              <VideoWrapper
                                embed={video}
                                embedCode={embed}
                                placeholder={_image}
                                label={label}
                                toEnlarge={true}
                              />
                            )}
                            {label ? (
                              <div
                                sx={{
                                  variant: 'text.regular_19',
                                  pt: 4,
                                  color: 'b5',
                                }}
                              >
                                {label}
                              </div>
                            ) : null}
                          </FlexCol>
                        )
                      })
                    : null}
                </FlexCols>
              </div>
            )
          })}
        </VStack>
      </Card>
    </>
  ) : null
}

export default Videos
